<template>
  <div class="authentication-wrapper authentication-3">
    <div class="authentication-inner">

      <!-- Side container -->
      <!-- Do not display the container on extra small, small and medium screens -->
      <div class="d-none d-lg-flex col-lg-8 align-items-center ui-bg-cover ui-bg-overlay-container p-5"
           :style="{ backgroundImage: 'url(' + require('@/assets/backgroubd_2.jpg') + ')' }">
        <div class="ui-bg-overlay bg-dark opacity-50"></div>
        <!-- Text -->
        <div class="w-100 text-white px-5">
        </div>
        <!-- /.Text -->
      </div>
      <!-- / Side container -->

      <!-- Form container -->
      <div class="d-flex col-lg-4 align-items-center bg-white p-5">
        <!-- Inner container -->
        <!-- Have to add `.d-flex` to control width via `.col-*` classes -->
        <div class="d-flex col-sm-7 col-md-5 col-lg-12 px-0 px-xl-4 mx-auto">
          <div class="w-100">
  
            <div style="text-align:right">
              <a href="#" style="color:#d1d2d3!important" @click="changeLanguage('fr')">FR</a> / <a style="color:#d1d2d3!important" href="#" @click="changeLanguage('en')">EN</a>
            </div>
            <div class="d-flex justify-content-center align-items-center">
              <div class="ui">
                <div class="w-100 position-relative" style="padding-bottom: 20px">
                  <img v-if="$cookie.get('language') == 'fr'" :src="require('@/assets/logo_plateform.jpg')" style="height:100px;"/>
                  <img v-if="$cookie.get('language') == 'en'" :src="require('@/assets/logo_keolis_en.jpg')" style="height:100px;"/>
                </div>
              </div>
            </div>
            <!-- / Logo -->

            <h4 class="text-center text-lighter font-weight-normal mt-2 mb-0">
              {{ $t('finish_signup')}}
            </h4>
            <!-- Form -->
            <form class="my-5" @submit="completeRegistration">
              <div v-if="errors['global']" role="alert"
                   aria-live="polite" aria-atomic="true" class="alert alert-dismissible alert-dark-danger"
              >
                {{ error }}
              </div>
              <div v-if="error" role="alert"
                   aria-live="polite" aria-atomic="true" class="alert alert-dismissible alert-dark-danger"
              >
                {{ error }}
              </div>
              <div>

              </div>
              <b-form-group>
                <div slot="label" class="d-flex justify-content-between align-items-end">
                  <div>{{ $t('password')}}</div>
                </div>
                <b-input :type="passwordFieldType" v-model="password" :state="errors.password ? 'invalid': ''" @input="password_check"/>
                <i @click="show_password" class="password-eye ion-md-eye"></i>
                <div class="form-validation">
                  <p>{{ $t('password_container')}}</p>
                  <p class="frmValidation" :class="{'frmValidation--passed' : password.length > 8}">
                    <i class="frmIcon ion" :class="password.length > 8 ? 'ion-md-checkmark' : 'ion-md-close'"></i> {{ $t('8_min_car')}}
                  </p>
                  <p class="frmValidation" :class="{'frmValidation--passed' :has_uppercase }">
                    <i class="frmIcon ion" :class="has_uppercase ? 'ion-md-checkmark' : 'ion-md-close'"></i> {{$t('1_min_maj')}}
                  </p>
                  <p class="frmValidation" :class="{'frmValidation--passed' :has_lowercase }">
                    <i class="frmIcon ion" :class="has_lowercase ? 'ion-md-checkmark' : 'ion-md-close'"></i> {{ $t('1_min_min')}}
                  </p>
                  <p class="frmValidation" :class="{'frmValidation--passed' : has_number }">
                    <i class="frmIcon ion" :class="has_number ? 'ion-md-checkmark' : 'ion-md-close'"></i> {{ $t('1_min_number')}}
                  </p>
                  <p class="frmValidation" :class="{'frmValidation--passed' : has_special }">
                    <i class="frmIcon ion" :class="has_special ? 'ion-md-checkmark' : 'ion-md-close'"></i> {{ $t('1_spe_carac_min')}}
                  </p>
                </div>

                <div v-if="errors['password']" class="invalid-tooltip">{{ errors['password'][0] }}</div>
              </b-form-group>
              <b-form-group>
                <div slot="label" class="d-flex justify-content-between align-items-end">
                  <div>{{ $t('confirm_password')}}</div>
                </div>
                <b-input :type="passwordConfirmFieldType" v-model="passwordConfirmed" :state="errors.passwordConfirmed ? 'invalid': ''" @input="password_check"/>
                <i @click="show_confirmed_password" class="password-eye ion-md-eye"></i>
                <div v-if="errors['passwordConfirmed']" class="invalid-tooltip">{{ errors['passwordConfirmed'][0] }}
                </div>
              </b-form-group>
              <b-form-group>
                <b-form-checkbox v-model="conditions" value=true
                                 unchecked-value=false>{{ $t('registration_checkbox')}}</b-form-checkbox>
              </b-form-group>
              <div class="d-flex justify-content-between align-items-center m-0">
                <b-btn v-if="enabledbutton === true" variant="primary" type="submit">{{ $t('finish_sub')}}</b-btn>
                <b-btn v-if="enabledbutton === false" disabled variant="primary" type="submit">{{ $t('finish_sub')}}</b-btn>
              </div>
            </form>
            <!-- / Form -->
  
            <div class="text-center text-muted">
              <a href="/confidentiality/">{{ $t('privacy')}}</a><br/>
              <a href="/legals/">{{ $t('legales')}}</a>&nbsp;-&nbsp;<a href="/cookies/">{{ $t('cookies_managment')}}</a>
            </div>

          </div>
        </div>
      </div>
      <!-- / Form container -->

    </div>
  </div>
</template>
<style>
  .form-validation {
    padding: 10px;
    border: 1px solid #5fb3d2;
    border-radius: 0px !important;
  }
  .form-validation p{ color: #5fb3d2; margin-bottom:5px;}
  .frmValidation { font-size: 11px; margin-left:20px; color:#FF0000 !important; margin-bottom:2px;}
  .frmValidation--passed{color:#008a00 !important;}
  .password-eye {
    float:right;
    margin-right:20px;
    margin-top:-30px;
    position:relative;
  }
</style>
<!-- Page -->
<style src="@/vendor/styles/pages/authentication.scss" lang="scss"></style>

<script>
  import { mapState } from 'vuex'
  import { COMPLETE_REGISTRATION_REQUEST } from '../_store/user/actiontypes'

  export default {
    name: 'home',
    mounted() {
      if (this.$cookie.get('language') === 'fr' || this.$cookie.get('language') === 'en'){
        this.$i18n.locale = this.$cookie.get('language')
      } else {
        this.$cookie.set('language', 'fr', 300);
        location.reload();
      }
    
    },
    data() {
      return ({
        passwordConfirmed: '',
        password: '',
        message:       '',
        error: false,
        conditions: false,
        has_number:    false,
        has_lowercase: false,
        has_uppercase: false,
        has_special:   false,
        enabledbutton: false,
        passwordFieldType: 'password',
        passwordConfirmFieldType: 'password'
      })
    },
    computed: mapState({ errors: state => state.authenticate.errors }),
    methods: {
      changeLanguage(language) {
        this.$cookie.set('language', language, 300);
        location.reload();
      },
      show_password: function () {
        this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
      },
      show_confirmed_password: function () {
        this.passwordConfirmFieldType = this.passwordConfirmFieldType === 'password' ? 'text' : 'password';
      },
      password_check: function () {
        this.has_number    = /\d/.test(this.password);
        this.has_lowercase = /[a-z]/.test(this.password);
        this.has_uppercase = /[A-Z]/.test(this.password);
        this.has_special   = /[!@#\$%\^\&*\)\(+=._-]/.test(this.password);
        if (this.has_number && this.has_lowercase && this.has_uppercase && this.has_special && this.password.length > 8 && this.password === this.passwordConfirmed) {
          this.enabledbutton = true
        }
      },
      completeRegistration(e) {
        e.preventDefault()
        const { password } = this;
        if (this.conditions === false){
            this.error = "Veuillez accepter les mentions légales et la politique de confidentialité de la plateforme";
        }
        else{
          this.error = false;
          this.$store.dispatch(COMPLETE_REGISTRATION_REQUEST, {
            password: password,
            token: this.$route.params.token,
            conditions: this.conditions,
          })
                .then(() => {
                  this.$router.push('/')
                })
                .catch((error) => {
                  console.log('error is ==')
                  console.log(error)
                })
        }
        
      }
    }
  }
</script>
